/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var AddressDisplayView = require('common/views/AddressDisplayView');

var tmplDepIrregularityDetailsSectionView = require('../templates/DepIrregularityDetailsSectionView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepIrregularityDetailsSectionView,

  className: 'dep-irregularity-details-section-view',

  ui: {
    addressContainer: '.address-container'
  },

  regions: {
    addressContainer: '@ui.addressContainer'
  },

  templateHelpers: function() {
    var individualName = (
      (this.model.get('firstName') || '') +
      ' ' +
      (this.model.get('middleName') || '') +
      ' ' +
      (this.model.get('lastName') || '')
    )
      .replace(/\s+/g, ' ')
      .trim();
    return {
      individualName: individualName
    };
  },

  onBeforeShow: function() {
    Syphon.deserialize(this, this.model.toJSON());

    this.showChildView(
      'addressContainer',
      new AddressDisplayView({
        model: new Backbone.Model(this.model.get('address'))
      })
    );
  }
});
